import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';

export default function RadianOAuthCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const ok = searchParams.get('oauth') === 'ok';

        Swal.fire({
            icon: ok ? 'success' : 'error',
            title: ok ? 'Cuenta conectada con éxito' : 'No se pudo conectar la cuenta',
            text: ok
                ? 'La cuenta de Outlook/Hotmail quedó conectada correctamente.'
                : 'Ocurrió un problema al conectar la cuenta con Microsoft. Intenta nuevamente.'
        }).then(() => {
            navigate(-1);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
